<template>
  <div>
    <div class="investment-box box-class">
      <div class="investment-title">加盟方式</div>
      <div class="investment-title-tips">Franchise Method</div>
      <!-- <div class="investment-service">技术支持/人才服务/保障服务/其他服务</div>
      <div class="investment-picture">
        <img src="@/assets/img/banner_01.png" alt="" v-for="i in 4" />
      </div> -->

      <!-- <div class="investment-method">
        <div class="investment-method-left">
          <div class="box-content" v-for="(item, i) in methodInfo" :key="i">
            <div class="title">{{ item[0] }}：</div>
            <div class="content">{{ item[1] }}</div>
          </div>
        </div>
        <div class="investment-method-right">
          <img src="@/assets/img/banner_01.png" alt="" />
          <div class="img-cover"></div>
          <div class="img-content">
            <div class="img-content-01">地理位置</div>
            <div class="img-content-02">
              公司总部位于珠三角的东莞松山湖，毗邻两个一线城市，广州和深圳，得益于这两座城市的产业外溢，东莞的经济发展速度得以加快。同时，作为粤港澳大湾区的主要核心城市之一，东莞未来发展潜力巨大，前景广阔。
            </div>
          </div>
        </div>
      </div> -->

      <div class="investment-info">
        <div class="contact-info">
          <div
            class="contact-item"
            v-for="(item, index) in methodInfo"
            :key="index"
          >
            <div class="contact-icon">
              <i class="iconfont" :class="item[2]"></i>
            </div>
            <div class="contact-details">
              <div class="title">{{ item[0] }}</div>
              <div class="text">{{ item[1] }}</div>
            </div>
          </div>
        </div>

        <div class="location-info">
          <div>
            <div class="title">地理位置</div>
            <div class="text">
              <img src="@/assets/img/banner_01.png" alt="" />
              <div class="img-cover"></div>
              <div class="img-content">
                公司总部位于珠三角的东莞松山湖，毗邻两个一线城市，广州和深圳，得益于这两座城市的产业外溢，东莞的经济发展速度得以加快。同时，作为粤港澳大湾区的主要核心城市之一，东莞未来发展潜力巨大，前景广阔。
              </div>
              <div class="img-content-copy">
                公司总部位于珠三角的东莞松山湖，毗邻两个一线城市，广州和深圳，得益于这两座城市的产业外溢，东莞的经济发展速度得以加快。同时，作为粤港澳大湾区的主要核心城市之一，东莞未来发展潜力巨大，前景广阔。
              </div>
            </div>
          </div>

          <div class="address">
            <div class="address-text">
              <i class="iconfont icon-dingweiweizhi2"></i
              >地址：东莞市松山湖总部一路6号
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { initAnimateScroll } from "@/utils/animateScroll.js";

export default {
  name: "investment",
  data() {
    return {
      name: "技师提现记录",
      methodInfo: [
        { 0: "电话", 1: "18098203827", 2: "icon-dianhua" },
        { 0: "传真", 1: "yifu@yifudj.com", 2: "icon-chuanzhen" },
        { 0: "邮箱", 1: "yifu@yifudj.com", 2: "icon-youxiang" },
        { 0: "网址", 1: "https://api.yifudj.com/h5", 2: "icon-wangzhi" },
        // { 0: "地址", 1: "东莞市松山湖总部一路6号" },
      ],
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted

    initAnimateScroll({
      selectors: [".investment-title", ".investment-title-tips"],
      animation: "fadeIn", // Animate.css动画名
      staggerDelay: 100, // 每个元素延迟150ms
      threshold: 0.05, // 20%进入视口时触发
      rootMargin: "0px 0px -100px 0px",
    });

    initAnimateScroll({
      selectors: [".contact-info"],
      animation: "fadeInLeftBig", // Animate.css动画名
      staggerDelay: 100, // 每个元素延迟150ms
      threshold: 0.05, // 20%进入视口时触发
      rootMargin: "0px 0px -100px 0px",
    });

    initAnimateScroll({
      selectors: [".location-info"],
      animation: "fadeInRightBig", // Animate.css动画名
      staggerDelay: 100, // 每个元素延迟150ms
      threshold: 0.05, // 20%进入视口时触发
      rootMargin: "0px 0px -100px 0px",
    });
  },
};
</script>

<style module>
:root {
  --theme-title-color: #2c5530;
  --theme-title-tips-color: rgba(122, 158, 126, 0.8);
  --theme-icon-bg-color: #f0f7f0;
  --text-color: #333;
  --text-light: #666;
}
</style>

<style lang="less" scoped>
.investment-box {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 35px 0;

  .investment-title {
    font-size: 0.5692rem;
    font-weight: bold;
    color: var(--theme-title-color);
    padding: 5.0031px 6.0024px;
    border-bottom: 1px solid var(--theme-title-tips-color);
  }

  .investment-title-tips {
    font-size: 0.1897rem;
    color: var(--theme-title-tips-color);
    margin-top: 0.0791rem;
  }

  .investment-service {
    font-size: 0.2846rem;
    font-weight: 500;
    margin-top: 20px;
  }

  .investment-picture {
    width: 8.6957rem;
    height: 4.7431rem;
    min-width: 275px;
    min-height: 190px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    align-items: center;

    img {
      width: 35%;
      min-width: 100px;
      height: 40%;
      min-height: 80px;
      margin: 0.1581rem 0.3162rem;
      border-radius: 10px;
    }
  }
}

.box-class {
  background-color: #f1f0ec;
}

.box-class2 {
  background-color: #ffffff;
  padding-bottom: 0px;
}

.investment-method {
  width: 11.0672rem;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.3162rem;

  .investment-method-left {
    width: 5.0593rem;
    min-width: 260px;
    height: 3.8462rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    margin-top: 30px;

    .box-content {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 15px;
      height: 20px;
      line-height: 20px;

      .title {
        width: 20%;
        height: 100%;
        text-align: end;
        letter-spacing: 1px;
      }

      .content {
        width: 70%;
        height: 100%;
        text-align: start;
        border-bottom: 1px solid #c2c2c2;
        font-size: 13px;
        font-weight: bold;
      }
    }
  }

  .investment-method-right {
    width: 5.0593rem;
    min-width: 260px;
    height: 3.8462rem;
    border-radius: 10px;
    overflow: hidden;
    position: relative;
    margin-top: 30px;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }

    .img-cover {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      background-color: rgba(77, 77, 77, 0.5);
    }

    .img-content {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      color: #ffffff;
      padding: 20px 15px;
      box-sizing: border-box;

      .img-content-01 {
        text-align: center;
        font-size: 0.3478rem;
      }

      .img-content-02 {
        margin-top: 5px;
        text-indent: 2em;
        text-align: left;
        font-size: 0.253rem;
      }
    }
  }
}

.investment-info {
  width: auto;
  height: auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;

  .contact-info {
    width: 5.5336rem;
    min-width: 300px;
    max-width: 450px;
    height: 7.9051rem;
    min-height: 450px;
    max-height: 600px;
    background: #fff;
    border-radius: 20px;
    padding: 0.6324rem;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: 20px 20px 0;

    .contact-item {
      display: flex;
      align-items: center;
      margin-bottom: 25px;
      padding-bottom: 25px;
      border-bottom: 1px solid #eee;
    }

    .contact-item:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }

    .contact-icon {
      width: 60px;
      height: 60px;
      background: var(--theme-icon-bg-color);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      flex-shrink: 0;

      i {
        font-size: 24px;
        color: var(--theme-title-color);
      }
    }

    .contact-details {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .title {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 5px;
        color: var(--text-color);
        display: flex;
        justify-content: start;
      }

      .text {
        color: var(--text-light);
        font-size: 16px;
      }
    }
  }

  .contact-info:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
  }

  .location-info {
    width: 5.5336rem;
    min-width: 300px;
    max-width: 450px;
    height: 7.9051rem;
    min-height: 450px;
    max-height: 600px;
    background: #fff;
    border-radius: 20px;
    padding: 0.6324rem;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    overflow: hidden;
    box-sizing: border-box;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin: 20px 20px 0;

    .title {
      font-size: 20px;
      text-align: start;
      font-weight: 600;
      margin-bottom: 0.3162rem;
      color: var(--theme-title-color);
      padding-bottom: 10px;
      overflow: hidden;
      box-sizing: border-box;
      position: relative;
    }

    .title::after {
      content: "";
      position: absolute;
      width: 50px;
      height: 3px;
      background: #7a9e7e;
      bottom: 0;
      left: 0;
    }

    .text {
      width: 100%;
      // height: 3.6364rem;
      font-size: 16px;
      color: var(--text-light);
      margin-bottom: 0.3162rem;
      line-height: 1.8;
      overflow: hidden;
      position: relative;
      border-radius: 10px;

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }

      .img-cover {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        background-color: rgba(77, 77, 77, 0.5);
      }

      .img-content {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        color: #ffffff;
        padding: 0.3162rem 0.2372rem;
        box-sizing: border-box;
      }

      .img-content-copy {
        z-index: 100;
        color: #ffffff;
        padding: 0.3162rem 0.2372rem;
        box-sizing: border-box;
      }
    }

    .address {
      background: var(--theme-icon-bg-color);
      padding: 0.2372rem;
      border-radius: 10px;
      font-size: 16px;

      .address-text {
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 18px;
          color: var(--theme-title-color);
          margin-right: 5px;
        }
      }
    }
  }

  .location-info:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.12);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Investment.vue